import { kycDetailsWithMAIDsReqPayload, kycDetailsWithMAIDsResponse } from "../modules/profile/Account.model";
import SendRequest from "../services/sendRequest.service";

  export const kycDetailsWithMaids = async ( payload: kycDetailsWithMAIDsReqPayload) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/kyc/kycDetailsWithMAIDs`;
    let response: kycDetailsWithMAIDsResponse = await SendRequest.instance.post(
        url,
        payload
    );
    return response;
  };
